// Globals
import { TFunction } from 'i18next';
import dayjs from 'dayjs';

// Models
import { GoogleMerchantSyncRunMode } from '@/models/googleMerchantSync.model';

// Components
import { FormItem } from '@/components';
import { DatePicker, Input } from '@/ui';

// Helpers
import { getRequiredRule } from '@/hooks';
import { GoogleMerchantSyncFormFields } from './types';

export const getGoogleMerchantSyncRunAdditionalFields = (syncRunMode: GoogleMerchantSyncRunMode, t: TFunction) => {
  switch (syncRunMode) {
    case GoogleMerchantSyncRunMode.PRODUCT:
      return (
        <FormItem
          rules={[getRequiredRule(t)]}
          label={t('label_product_sku')}
          name={GoogleMerchantSyncFormFields.PRODUCT_SKU}
        >
          <Input placeholder={t('placeholder_product_sku')} />
        </FormItem>
      );
    case GoogleMerchantSyncRunMode.DELTA:
      return (
        <FormItem rules={[getRequiredRule(t)]} label={t('label_since_date')} name={GoogleMerchantSyncFormFields.SINCE}>
          <DatePicker maxDate={dayjs()} style={{ width: '100%' }} />
        </FormItem>
      );
    default:
      return null;
  }
};
